export const renameProperty = (object, from, to) => {
  let result = { ...object, [to]: object[from] };
  delete result[from];
  return result;
};
